import styled from 'styled-components';

const AdditionalLine = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export default AdditionalLine;
